export * from './feld-kategories-list.component';
export * from './feld-kategories-list.component.module';